import VDialogPersonnel from './index.vue';

export default {
  install: (Vue) => Vue.component('VDialogPersonnel', VDialogPersonnel),
};
